import React from 'react';
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Space,
  Table
} from "antd";



import { useState } from 'react';
import { useEffect } from 'react';
import enrollmentService from "../../../api/enrollment.service";


import { Link } from 'react-router-dom';
import { SUCCESS_STATUS } from "../../../utility/Constants";
import ProgrammeService from "../../../api/programme.service";
import CustomTableSearch from "../../common/CustomTableSearch";




const JcpMonthlyPaidListView = ({jcpMonthlyPaidList}) => {





  const columns = [
    {
        title: 'Receipt No',
        dataIndex: 'payment_no',
        key: 'payment_no',
  
      },
      {
        title: 'Payment Date',
        dataIndex: 'payment_date',
        key: 'payment_date',
  
      },
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',

    },
    {
      title: 'Total Month ',
      dataIndex: 'no_of_months',
      key: 'no_of_months',
    },
    {
      title: 'Total Paid',
      dataIndex: 'net_payble_amount',
      key: 'net_payble_amount',
    },
    


    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (

        <Space size="middle">
          {/* {
            console.log("slectedObj", selectedObj)
          } */}
          <Link to={`/jcp-monthly/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} >
            <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
          </Link>
        </Space>
      ),
    },
  ];



  




  return (
    <>

      {/* <CustomTableSearch onSearchTable={onSearch} /> */}
      <Table columns={columns} rowKey='receipt_master_id' dataSource={jcpMonthlyPaidList} />

    </>
  );
};

export default JcpMonthlyPaidListView;